<div class="webhook-manager">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold">Webhook- & Ereignisbenachrichtigungen</h3>
        <span *ngIf="unacknowledgedAlertCount > 0" class="badge badge-danger">
            {{unacknowledgedAlertCount}} Warnung(en)
        </span>
    </div>

    <!-- Error/Success Messages -->
    <div *ngIf="error" class="p-3 mb-4 bg-red-100 text-red-700 rounded-md">
        <i class="fa-solid fa-circle-exclamation mr-2"></i>{{error}}
        <button class="float-right" (click)="clearMessages()">
            <i class="fa-solid fa-times"></i>
        </button>
    </div>
    <div *ngIf="successMessage" class="p-3 mb-4 bg-green-100 text-green-700 rounded-md">
        <i class="fa-solid fa-check-circle mr-2"></i>{{successMessage}}
        <button class="float-right" (click)="clearMessages()">
            <i class="fa-solid fa-times"></i>
        </button>
    </div>

    <!-- Tabs -->
    <div class="flex border-b mb-4">
        <button class="px-4 py-2" [class.border-b-2]="activeTab === 'subscriptions'"
                [class.border-blue-500]="activeTab === 'subscriptions'"
                (click)="activeTab = 'subscriptions'">
            Abonnements
        </button>
        <button class="px-4 py-2" [class.border-b-2]="activeTab === 'webhooks'"
                [class.border-blue-500]="activeTab === 'webhooks'"
                (click)="activeTab = 'webhooks'">
            Verfügbare Webhooks
        </button>
        <button class="px-4 py-2" [class.border-b-2]="activeTab === 'history'"
                [class.border-blue-500]="activeTab === 'history'"
                (click)="activeTab = 'history'">
            Zustellungsverlauf
        </button>
        <button class="px-4 py-2 relative" [class.border-b-2]="activeTab === 'alerts'"
                [class.border-blue-500]="activeTab === 'alerts'"
                (click)="activeTab = 'alerts'">
            Warnungen
            <span *ngIf="unacknowledgedAlertCount > 0"
                  class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {{unacknowledgedAlertCount}}
            </span>
        </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="flex justify-center py-8">
        <i class="fa-solid fa-spinner fa-spin text-2xl text-gray-500"></i>
    </div>

    <!-- Subscriptions Tab -->
    <div *ngIf="activeTab === 'subscriptions' && !loading">
        <!-- Current Subscriptions -->
        <div class="mb-6">
            <h4 class="font-medium mb-3">Aktive Webhook-Abonnements</h4>
            <div *ngIf="subscriptions.length === 0" class="text-gray-500 p-4 bg-gray-50 rounded-md">
                Keine Webhooks für diese Kampagne konfiguriert.
            </div>
            <div *ngFor="let sub of subscriptions" class="p-4 border rounded-md mb-2 flex justify-between items-center">
                <div>
                    <span class="font-medium">{{sub.webhookDtoName}}</span>
                    <div class="text-sm text-gray-500">
                        Abonniert: {{sub.subscribedAt | date:'short'}}
                        <span *ngIf="sub.eventFiltersJson" class="ml-2">
                            | Ereignisse: {{parseEventFilters(sub.eventFiltersJson).join(', ')}}
                        </span>
                    </div>
                </div>
                <div class="flex gap-2">
                    <button class="btn btn-sm btn-outline" (click)="loadDeliveryHistory(sub.webhookDtoId); activeTab = 'history'">
                        <i class="fa-solid fa-history"></i> Verlauf
                    </button>
                    <button class="btn btn-sm btn-danger" (click)="unsubscribeFromWebhook(sub.webhookDtoId)">
                        <i class="fa-solid fa-unlink"></i> Entfernen
                    </button>
                </div>
            </div>
        </div>

        <!-- Add Subscription -->
        <div class="border-t pt-4">
            <h4 class="font-medium mb-3">Webhook-Abonnement hinzufügen</h4>
            <div class="grid grid-cols-2 gap-4">
                <div>
                    <label class="block text-sm font-medium mb-1">Webhook auswählen</label>
                    <select [(ngModel)]="selectedWebhookId" class="form-select w-full">
                        <option [ngValue]="null">-- Webhook auswählen --</option>
                        <option *ngFor="let webhook of availableWebhooks" [ngValue]="webhook.id">
                            {{webhook.name}}
                        </option>
                    </select>
                </div>
                <div>
                    <label class="block text-sm font-medium mb-1">Ereignisfilter (optional)</label>
                    <select multiple [(ngModel)]="selectedEventFilters" class="form-select w-full" size="4">
                        <option *ngFor="let opt of eventFilterOptions" [value]="opt.value">
                            {{opt.label}}
                        </option>
                    </select>
                    <p class="text-xs text-gray-500 mt-1">Strg/Cmd gedrückt halten, um mehrere Ereignisse auszuwählen</p>
                </div>
            </div>
            <button class="btn btn-primary mt-4" [disabled]="!selectedWebhookId" (click)="subscribeToWebhook()">
                <i class="fa-solid fa-plug"></i> Webhook abonnieren
            </button>
        </div>
    </div>

    <!-- Available Webhooks Tab -->
    <div *ngIf="activeTab === 'webhooks' && !loading">
        <div *ngIf="availableWebhooks.length === 0" class="text-gray-500 p-4 bg-gray-50 rounded-md">
            Keine Webhooks verfügbar. Erstellen Sie einen Webhook im Konfigurationsbereich.
        </div>
        <div *ngFor="let webhook of availableWebhooks" class="p-4 border rounded-md mb-2">
            <div class="flex justify-between items-start">
                <div>
                    <span class="font-medium">{{webhook.name}}</span>
                    <span *ngIf="webhook.isActive" class="ml-2 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">Aktiv</span>
                    <span *ngIf="!webhook.isActive" class="ml-2 text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded">Inaktiv</span>
                    <div class="text-sm text-gray-500 mt-1">
                        URL: {{webhook.url}}
                    </div>
                    <div *ngIf="webhook.lastDeliveryAt" class="text-sm text-gray-500">
                        Letzte Zustellung: {{webhook.lastDeliveryAt | date:'short'}}
                        <span *ngIf="webhook.lastDeliverySuccessful" class="text-green-600">(Erfolg)</span>
                        <span *ngIf="!webhook.lastDeliverySuccessful" class="text-red-600">(Fehlgeschlagen)</span>
                    </div>
                </div>
                <div class="flex gap-2">
                    <button class="btn btn-sm btn-outline" [disabled]="testing" (click)="testWebhook(webhook.id)">
                        <i class="fa-solid fa-vial" *ngIf="!testing"></i>
                        <i class="fa-solid fa-spinner fa-spin" *ngIf="testing"></i>
                        Testen
                    </button>
                    <button class="btn btn-sm btn-outline" (click)="loadDeliveryHistory(webhook.id); activeTab = 'history'">
                        <i class="fa-solid fa-history"></i> Verlauf
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Delivery History Tab -->
    <div *ngIf="activeTab === 'history' && !loading">
        <!-- Stats Summary -->
        <div *ngIf="deliveryStats" class="grid grid-cols-3 gap-4 mb-4">
            <div class="p-4 bg-gray-50 rounded-md text-center">
                <div class="text-2xl font-bold text-yellow-600">{{deliveryStats.pendingCount}}</div>
                <div class="text-sm text-gray-500">Ausstehend</div>
            </div>
            <div class="p-4 bg-gray-50 rounded-md text-center">
                <div class="text-2xl font-bold text-red-600">{{deliveryStats.failedCount}}</div>
                <div class="text-sm text-gray-500">Fehlgeschlagen</div>
            </div>
            <div class="p-4 bg-gray-50 rounded-md text-center">
                <div class="text-2xl font-bold text-green-600">{{(deliveryStats.successCount || 0)}}</div>
                <div class="text-sm text-gray-500">Erfolgreich</div>
            </div>
        </div>

        <!-- History Table -->
        <div *ngIf="deliveryHistory.length === 0" class="text-gray-500 p-4 bg-gray-50 rounded-md">
            Kein Zustellungsverlauf verfügbar. Wählen Sie einen Webhook aus, um den Verlauf anzuzeigen.
        </div>
        <table *ngIf="deliveryHistory.length > 0" class="w-full border-collapse">
            <thead>
                <tr class="border-b">
                    <th class="text-left p-2">Ereignistyp</th>
                    <th class="text-left p-2">Status</th>
                    <th class="text-left p-2">Versuche</th>
                    <th class="text-left p-2">Letzter Versuch</th>
                    <th class="text-left p-2">Antwort</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let delivery of deliveryHistory" class="border-b hover:bg-gray-50">
                    <td class="p-2">{{delivery.eventType}}</td>
                    <td class="p-2" [class]="getDeliveryStatusClass(delivery.deliveryStatus?.toString())">
                        {{delivery.deliveryStatus}}
                    </td>
                    <td class="p-2">{{delivery.attemptCount}}</td>
                    <td class="p-2">{{delivery.lastAttemptAt | date:'short'}}</td>
                    <td class="p-2">
                        <span *ngIf="delivery.responseStatusCode">HTTP {{delivery.responseStatusCode}}</span>
                        <span *ngIf="delivery.errorMessage" class="text-red-600 text-sm">{{delivery.errorMessage}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Alerts Tab -->
    <div *ngIf="activeTab === 'alerts' && !loading">
        <div *ngIf="alerts.length === 0" class="text-gray-500 p-4 bg-gray-50 rounded-md">
            <i class="fa-solid fa-check-circle mr-2 text-green-500"></i>
            Keine unbestätigten Warnungen.
        </div>
        <div *ngFor="let alert of alerts" class="p-4 border border-red-200 rounded-md mb-2 bg-red-50">
            <div class="flex justify-between items-start">
                <div>
                    <span class="font-medium text-red-700">
                        <i class="fa-solid fa-triangle-exclamation mr-2"></i>
                        {{alert.alertType}}
                    </span>
                    <div class="text-sm mt-1">{{alert.alertMessage}}</div>
                    <div class="text-xs text-gray-500 mt-1">
                        Gewarnt: {{alert.alertedAt | date:'short'}}
                        | Aufeinanderfolgende Fehler: {{alert.consecutiveFailures}}
                    </div>
                </div>
                <button class="btn btn-sm btn-outline" (click)="acknowledgeAlert(alert.id)">
                    <i class="fa-solid fa-check"></i> Bestätigen
                </button>
            </div>
        </div>
    </div>
</div>
